export function extractRouteCore(name: string) {
    const lastIndex = name.lastIndexOf('S');
    return name.slice(0, lastIndex <= 0 ? name.length : lastIndex);
}